<template>
  <div>
    <vx-card class="mt-base mb-5" :title="activityTitle">
      <p class="mb-5">
        <strong>You Will Need:</strong> Word processing software (such as Google Docs or Microsoft
        Word), a camera or microphone if desired, or access to presentation software (such as Google
        Slides or Microsoft PowerPoint).
      </p>
      <p class="mb-5">
        An elevator pitch is where you present your business idea to someone within about 30 seconds
        to 2 minutes. It’s called that based on the idea that you might run into your boss or a
        potential investor in the lift, so you want to put your best foot forward and create an
        opportunity to show them your amazing business plan later.
      </p>
      <p class="mb-5">
        Your task is to come up with a 30 second to 2 minute elevator pitch, and submit it as a
        written script, a presentation or a video.
      </p>
      <p class="mb-5">
        Take a look below for the components of a great elevator pitch. Remember that it’s meant to
        be short, snappy and exciting! You want your potential investor or customer to want to find
        out more.
      </p>
      <p class="mb-5">
        In the explanation we’ll use the example of a business that delivers quality fresh fruit to
        customers’ front door at an affordable price. You can use the example of the fun-to-use
        toothbrush explained in the introduction, or come up with your own creative product idea.
      </p>
      <p class="mb-5 text-bold">1. Identify the problem or opportunity</p>
      <p class="mb-5">
        Start with the problem you are looking to solve, as well as why it’s important. This is a
        great opportunity to bring out some statistics to show you know your stuff.
      </p>
      <p class="mb-5">
        “Over 60% of Australians today aren’t getting their 2 serves of fruit a day. Fruit is packed
        with fibre, vitamins and minerals that help us live healthy, happy lives, but according to
        our research, 70% of families say they don’t have the time or money to buy the fresh fruit
        they need”.
      </p>
      <p class="mb-5 text-bold">2. Tell them what the solution is</p>
      <p class="mb-5">
        “Our solution? A delivery service that brings organic, fresh fruit to your doorstep in time
        to get packed into your lunchbox or eaten for breakfast”
      </p>
      <p class="mb-5 text-bold">
        3. Tell them what makes your solution unique and better than the competition
      </p>
      <p class="mb-5">
        “We use a network of delivery bicycle riders all travelling from your local shops to make
        sure our fruit is delivered fresher, faster and more affordably than our market competitors”
      </p>
      <p class="mb-5 text-bold">
        4. Give them any data or proof you have that your solution is or will be successful
      </p>
      <p class="mb-5">
        “So far we’ve signed up three suburbs in Sydney to the service, where we are now delivering
        fruit to over 80% of the homes in the area”
      </p>
      <p class="mb-5 text-bold">5. Seal the deal with a call to action.</p>
      <p class="mb-5">
        “If you’re interested in investing, I’d love to schedule a meeting with you when you’re
        available. Here’s my business card where you’ll find all my contact information.”
      </p>

      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_1']"
        :is-editable="isEditable"
        filetype="doc"
        index="1"
        key="1"
      />

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
